export const VipShowData = [  // 卡片配置内容
    { "name": "VIP", "title": "VIP原价", "cont": "15元活动价5元" },
    { "name": "SVIP", "title": "SVIP原价", "cont": "30元活动价20元" }
]

export const EventShowData = {  // 活动时间块内容
    "title": "活动时间：", "cont": "2026.04.01-2026.08.01"
}

export const isShowEvent = true;  // 是否展示活动时间块

export const QrCodeText = "添加左边客服二维码，发送【购买VIP】或【购买SVIP】+你的用户名的字样。客服会发送一个订单号。例：【xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx】将订单号输入到下面文本框中，点击验证";  // 二维码说明操作信息

export const Authorization_text = "验证后以上订单状态显示【支付中】时，向客服支付对应金额。成功支付后以上订单状态显示【已激活】。同时客服会给你一个授权码，将授权码输入到以下文本框中进行授权，成功后会自动跳转，未成功请疯狂咨询客服！";  // 是否展示活动时间块

export const kefuQR = "//www.aboluo.site/api/uploadsl/vue/kefu.png"; 

export const EquitiesData = [  // VIP和SVIP权益部分解释
    {
        "title": "VIP", "cont": [
            { "title": "延长图片有效期", "isEffectivity": true },
            { "title": "获得积分 X 2", "isEffectivity": true },
            { "title": "非同盟查询", "isEffectivity": false }
        ], "isOver": false
    },
    {
        "title": "SVIP", "cont": [
            { "title": "延长图片有效期", "isEffectivity": true },
            { "title": "获得积分 X 3", "isEffectivity": true },
            { "title": "非同盟查询", "isEffectivity": true }
        ], "isOver": true
    }
];  // 是否展示活动时间块